import * as React from 'react';

import { Box, Button, Image, MainContentWrapper, Typography } from "components";

import { ErrorImage } from 'images';
import { TEXT } from 'texts';
import { observer } from 'mobx-react-lite';
import { paths } from 'routing';
import { useHistory } from 'react-router-dom';
import { useStores } from 'hooks';
import { useStyles } from './Error.styles';
import { useTranslation } from 'react-i18next';

const Error = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { dataStore } = useStores();
  const styles = useStyles();

  const handleClick = () => {
    if (!dataStore.appData) {
      window.location.replace('https://sensebank.com.ua/');
    } else {
      history.push(paths.main);
    }
  };

  return (
    <MainContentWrapper>
      <Box className={styles.root}>
        <Box mt={4}>
          <Image {...ErrorImage} height={300} />
        </Box>
        <Box mt={3}>
          <Typography className={styles.text} align="center">
            {t(TEXT.failTransfer)}
          </Typography>
          <Typography textColor="grey" align="center">
            {t(TEXT.tryLater)}
          </Typography>
        </Box>
        <Button className={styles.button} fullWidth type="button" onClick={handleClick}>
          {t(TEXT.close)}
        </Button>
      </Box>
    </MainContentWrapper>
  );
};

export default observer(Error);
